import { cva } from 'class-variance-authority';
const itemVariantDefinitions = {
    default: '',
    outline: 'border border-border',
    muted: 'bg-secondary text-secondary-foreground',
    'accent': [
        'h-[42px] px-4 rounded-[7px] border-0 bg-white justify-center',
        'whitespace-nowrap cursor-pointer transition-shadow duration-200',
        'text-[13px] font-normal leading-[150%] tracking-[0.18px] text-[#4A6476]',
    ].join(' '),
};
const itemSizeDefinitions = {
    default: 'p-4',
    sm: 'p-3 text-sm',
    xs: 'p-2 text-xs',
};
const itemStateDefinitions = {
    default: '',
    active: '',
    disabled: '',
};
export const itemVariants = cva('flex flex-col w-full rounded-lg', {
    variants: {
        variant: itemVariantDefinitions,
        size: itemSizeDefinitions,
        state: itemStateDefinitions,
    },
    compoundVariants: [
        {
            variant: 'accent',
            state: 'default',
            class: 'shadow-[inset_0_0_0_1px_rgba(7,23,39,0.17)] hover:shadow-[inset_0_0_0_1px_#DD0935]',
        },
        {
            variant: 'accent',
            state: 'active',
            class: 'font-medium text-[#DD0935] shadow-[inset_0_0_0_1.6px_#DD0935]',
        },
        {
            variant: 'accent',
            state: 'disabled',
            class: 'shadow-[inset_0_0_0_1px_rgba(7,23,39,0.17)] opacity-50 cursor-not-allowed pointer-events-none',
        },
    ],
    defaultVariants: {
        variant: 'default',
        size: 'default',
        state: 'default',
    },
});
export { default as ItemMedia } from './ItemMedia.vue';
export { default as ItemContent } from './ItemContent.vue';
export { default as ItemTitle } from './ItemTitle.vue';
export { default as ItemDescription } from './ItemDescription.vue';
export { default as ItemActions } from './ItemActions.vue';
export { default as ItemHeader } from './ItemHeader.vue';
export { default as ItemFooter } from './ItemFooter.vue';
export { default as ItemGroup } from './ItemGroup.vue';
export { default as ItemSeparator } from './ItemSeparator.vue';
